import { Subscription } from 'rxjs';
import { Component, OnInit, HostListener } from '@angular/core';
import {HttpClientService} from '../../Services/http-client.service';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../../app-settings';
import { ActivatedRoute, Router, NavigationStart } from '@angular/router';
import { SessionService } from '../../Services/session.service';

@Component({
  selector: 'app-activity-details-body',
  templateUrl: './activity-details-body.component.html',
  styleUrls: ['./activity-details-body.component.css']
})
export class ActivityDetailsBodyComponent implements OnInit {
  userRole:string;
  getActivityTypeData:any;
  /** True between Scholaranium's quiz-started and quiz-ended events: the sidebars stay hidden meanwhile. */
  cementingQuizInProgress: boolean = false;
  showContent:boolean = false;
  corelationID:string;
  sub:any;
  journeyCourseId:any = null;
  activityId: String;
  pageName: String;
  viewName = 'module';
  subscription: Subscription;

  constructor(private httpClientService: HttpClientService, private sessionService: SessionService, private router:ActivatedRoute, private route:Router) {

  }

  ngOnInit()
  {
    this.sub = this.router.params.subscribe(params => {

      if(params['page'] && (params['activity'] || params['subject'] || params['quizId']))
      {
        this.pageName = params["page"];
        this.activityId = params["activity"];
        this.showContent=true;
        window.scrollTo(0,0);
      }
      else if(params['corelationid'])
      {
          this.corelationID = params['corelationid'];
          this.redirect();
          this.showContent=false;

      }
      if(params['view']){
        this.viewName = params['view'];
      }

    });
    this.getForumsData();

  }


  getData() {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl +
          "/api/activity/" +
          this.activityId +
          "/page/" +
          this.pageName,
        headers
      )
      .subscribe((data) => {
        // console.log(data)
        this.journeyCourseId = data.courseJourneyId;
        this.showContent=true;
      });
  }
   redirect()
   {
    this.httpClientService.get(AppSettings.restApiUrl+'/api/forum/configuration/'+this.corelationID + '/',new HttpHeaders()).subscribe((data)=>{
      console.log(data);
      let appName = data.appName;
      let redirectionURL = data.uri;
      if(appName=="MIQA"){
          window.location.href = redirectionURL;
      }else if(appName=="SCHOLARANIUM"){
          window.location.href = redirectionURL;
      }else if(appName.indexOf("PRACTICE")!=-1||appName.indexOf("TRIAL")!=-1){
          window.location.href = redirectionURL;
      }else{
        this.showContent=true;
      }

    });
  }

  getForumsData()
  {
    let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl +
          '/api/user/roles', headers)
      .subscribe(
      (data) => {
        var userExpert = data.filter(function(obj){

          return obj.name == "ROLE_EXPERT";
        });
        if(userExpert.length>0)
        {
          this.userRole = 'expert';
        }
        else
        {
          this.userRole = 'student';
        }
        this.sessionService.shareUserRole(this.userRole);
      }
      );
  }


}
